import { PlayerSizesTypes } from '../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../common/styles/variables';

interface StylesObject {
  titleWrapperStyle: { [key: string]: any }[];
  titleLineWrapperStyle: { [key: string]: any }[];
  titleLineStyle: { [key: string]: any };
  getSingleWordStyle: (index: number) => { [key: string]: any };
}

const titleWrapper = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  transition: 'opacity ease-in',
  opacity: 0,
  extraSmall: {
    bottom: '12px',
    right: '4px',
    left: '4px',
  },
  small: {
    bottom: '12.4px',
    right: '11.3px',
    left: '4px',
  },
  medium: {
    bottom: '16px',
    right: '80px',
    left: '16px',
  },
  large: {
    bottom: '40px',
    right: '120px',
    left: '20px',
  },
  extraLarge: {
    bottom: '60px',
    right: '26px',
    left: '26px',
  },
  displayTitle: {
    opacity: 1,
  },
};

const titleLineWrapper = {
  background: SITE_VARIABLES.COLORS.GRAY,
  backdropFilter: 'blur(24px)',
  borderRadius: '4px',
  margin: '1px 0',
  padding: '1px 6px',
  width: 'fit-content',
  extraSmall: {
    padding: '1px 4px',
    backdropFilter: 'blur(14.5px)',
    borderRadius: '2px',
    margin: '0.6px 0',
  },
  small: {
    padding: '1px 4px',
    backdropFilter: 'blur(14.5px)',
    borderRadius: '2px',
    margin: '0.6px 0',
  },
  extraLarge: {
    padding: '1px 10px',
  },
};

const titleLine = {
  display: 'flex',
  color: 'white',
  fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
  fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
  fontWeight: '900',
  textTransform: 'uppercase',
  letterSpacing: '0.005em',
  lineHeight: '140%',
  width: 'fit-content',
  whiteSpace: 'nowrap',
  extraSmall: {
    fontSize: SITE_VARIABLES.FONT_SIZE.EXTRA_TINY,
    fontWeight: '600',
  },
  small: {
    fontWeight: '600',
    fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
  },
  medium: {
    fontSize: SITE_VARIABLES.FONT_SIZE.SMALL,
  },
  large: {
    fontSize: '20px',
  },
  extraLarge: {
    fontSize: '26px',
  },
};

const singleWord = (wordCalcIndex: number) => {
  return ({
    opacity: 0,
    transition: `opacity 0.4s cubic-bezier(0.11, 0, 0.5, 0) ${wordCalcIndex / 20}s`,
    displayWithTransition: {
      opacity: 1,
    },
  });
};

export const getStoriesTitleStyleObject = (showStoryTitle: boolean, playerSize: PlayerSizesTypes, isFullTitleByLines: boolean): StylesObject => {
  const extraSmallSize = playerSize === 'extraSmall';
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return {
    titleWrapperStyle: [
      titleWrapper,
      extraSmallSize && titleWrapper.extraSmall,
      smallSize && titleWrapper.small,
      mediumSize && titleWrapper.medium,
      largeSize && titleWrapper.large,
      extraLargeSize && titleWrapper.extraLarge,
      isFullTitleByLines && showStoryTitle && titleWrapper.displayTitle,
    ],
    titleLineWrapperStyle: [
      titleLineWrapper,
      extraSmallSize && titleLineWrapper.extraSmall,
      smallSize && titleLineWrapper.small,
      extraLargeSize && titleLineWrapper.extraLarge,
    ],
    titleLineStyle: [
      titleLine,
      extraSmallSize && titleLine.extraSmall,
      smallSize && titleLine.small,
      mediumSize && titleLine.medium,
      largeSize && titleLine.large,
      extraLargeSize && titleLine.extraLarge,
    ],
    getSingleWordStyle: (wordCalcIndex: number) => [
      singleWord(wordCalcIndex),
      isFullTitleByLines && showStoryTitle && singleWord(wordCalcIndex).displayWithTransition,
    ],
  };
};
